<template>
  <div class="page-content clientGroup">
    <h1 class="page-title">{{ $locale("sideMenu.clientManagement.clientGroup") }}</h1>

    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <el-col :span="14">
        <el-row :gutter="10">
          <el-col :span="14">
            <el-input :placeholder="$locale('form.plsEnterYourName')" v-model="searchFilter.name">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-col>
          <el-col :span="10">
            <el-button class="egl-btn-yellow" @click="getClientGroupList"
            >{{ $locale("global.search") }}</el-button>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="10" class="ta-r">
        <el-button class="egl-btn-yellow" type="primary" @click="addClientGroupAction"
          >{{ $locale("global.create") }}</el-button>
      </el-col>
    </el-row>

      <el-table
        class="egl-table list-table"
        :data="tableData"
        :stripe="true"
      >
        <el-table-column
          :label="$locale('client.partner.classification.name')"
          prop="name"
          min-width="300"
        ></el-table-column>
        <el-table-column align="center"
          :label="$locale('client.partner.subsidy.subject')+'1'+$locale('client.partner.subsidy.journal')"
          prop="auxiliaryCourse1"
          min-width="200"
        ></el-table-column>
        <el-table-column align="center"
          :label="$locale('client.partner.subsidy.subject')+'2'+$locale('client.partner.subsidy.journal')"
          prop="auxiliaryCourse2"
          min-width="200"
        ></el-table-column>
        <el-table-column align="center"
          :label="$locale('client.partner.subsidy.subject')+'3'+$locale('client.partner.subsidy.journal')"
          prop="auxiliaryCourse3"
          min-width="200"
        ></el-table-column>
        <el-table-column :label="$locale('global.control')" align="center" width="130">
          <template slot-scope="scope">
            <div class="handle">
              <a @click="updateClientGroupAction(scope.row)">{{ $locale("global.edit") }}</a>
              <template v-if="scope.row.isDelete">
                <el-divider direction="vertical"></el-divider>
                <a @click="deleteItem(scope.row)">{{ $locale("global.delete") }}</a>
              </template>
            </div>
          </template>
        </el-table-column>
      </el-table>

    <el-dialog
      :visible.sync="dialogVisible"
      width="660px"
      class="egl-dialog-elm"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <div slot="title" class="dialog-header">{{ $locale('client.modal.group.title') }}</div>
        <el-form
          label-position="top"
          :model="clientGroupDetailData"
          :rules="rules"
          ref="clientGroupForm"
        >
          <!-- <el-form-item label="取引先区分名">
            <p>{{ clientGroupDetailData.name }}</p>
          </el-form-item> -->
          <el-form-item :label="$locale('client.partner.classification.name')" prop="name" >
            <el-input :placeholder="$locale('setting.brand.p.businesscode')" v-model="clientGroupDetailData.name" :disabled="!clientGroupDetailData.isDelete && isUpdate"/>
          </el-form-item>
          <el-form-item :label="$locale('client.partner.classification')+'1 ('+$locale('bookKeeping.journal.subclass')+')'" prop="auxiliaryCourse1">
            <el-input :placeholder="$locale('setting.brand.p.businesscode')" v-model="clientGroupDetailData.auxiliaryCourse1" />
          </el-form-item>
          <el-form-item :label="$locale('client.partner.classification')+'2 ('+$locale('bookKeeping.journal.subclass')+')'" prop="auxiliaryCourse2">
            <el-input :placeholder="$locale('setting.brand.p.businesscode')" v-model="clientGroupDetailData.auxiliaryCourse2" />
          </el-form-item>
          <el-form-item :label="$locale('client.partner.classification')+'3 ('+$locale('bookKeeping.journal.subclass')+')'" prop="customer">
            <el-input :placeholder="$locale('setting.brand.p.businesscode')" v-model="clientGroupDetailData.auxiliaryCourse3" />
          </el-form-item>
        </el-form>
      <div slot="footer" class="dialog-footer">
        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-button @click="closeDialog" class="egl-btn-white">{{
              $locale("global.cancel")
            }}</el-button>
          </el-col>
          <el-col :span="10">
            <el-button
              type="primary"
              @click="submitClientDetailForm"
              class="egl-btn-yellow"
            >
              {{ $locale("global.confirm") }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "@/assets/style/client.less";
import {
  getClientGroupListService,
  delClientGroupService,
  addClientGroupService,
  updateClientGroupService,
  // clientDetailGroupService,
} from "@/helpers/service/api/client";
import countDownAlert from "@/utils/countDownAlert";

export default {
  data() {
    return {
      brandId: window.localStorage.getItem("brandId"),
      dialogVisible: false,
      tableData: [],
      clientGroupDetailData: this.initDetailsForm(),
      isUpdate: false,
      searchFilter: { name: "" },
      rules: {
        name: [
          { required: true,
            message: this.$locale("client.partner.classification.name")+this.$locale("client.text.needed"),
            trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.getClientGroupList();
  },
  methods: {
    initDetailsForm() {
      return {
        auxiliaryCourse1: "",
        auxiliaryCourse2: "",
        auxiliaryCourse3: "",
        name: "",
      };
    },
    openDialog() {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.$refs.clientGroupForm.resetFields();
      this.clientGroupDetailData = this.initDetailsForm();
    },
    getClientGroupList() {
      getClientGroupListService({
        page: 0,
        pageSize: 9999,
        ...(this.searchFilter.name ? { queryKey : this.searchFilter.name } : {}),
      }).then(res => {
        this.tableData = res.data.data;
      });
    },
    updateClientGroupAction(rowData) {
      this.clientGroupDetailData = { ...rowData };
      this.isUpdate = true;
      this.openDialog();
    },
    addClientGroupAction() {
      this.isUpdate = false;
      this.openDialog();
    },
    delClientGroupAction(id) {
      delClientGroupService({ gid: id }).then(() => {
        countDownAlert({
          content: this.$locale("global.deleteSuccessfully"),
          callback: () => {
            this.getClientGroupList();
          }
        });
      });
    },
    submitClientDetailForm() {
      this.$refs.clientGroupForm.validate(valid => {
        if (valid) {
          const requestScuessFn = str => {
            this.closeDialog();

            countDownAlert({
              content: str,
              callback: () => {
                this.getClientGroupList();
              }
            });
          };

          const requestParam = {
            ...this.clientGroupDetailData,
            brandId: this.brandId,
          };

          if (!this.isUpdate) {
            addClientGroupService(requestParam).then(() => {
              requestScuessFn(this.$locale("global.createSuccessfully"));
            });
          } else {
            updateClientGroupService(requestParam).then(() => {
              requestScuessFn(this.$locale("global.updateSuccessfully"));
            });
          }
        } else {
          return false;
        }
      });
    },
    deleteItem(row) {
      let confirmHtml = "";
      confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${
        row.name
      } ?</span>`;
      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      })
        .then(() => {
          this.delClientGroupAction(row.id);
        })
        .catch(() => {});
    },
  }
};
</script>
